jQuery( document ).ready(function( $ ) {

$( document ).on( 'click', 'body.page-template-ressources #main article > a', function(){ 
	var category = $( '.ribbon', $( this ) ).text().toLowerCase();
	
	dataLayer.push({
		'event': 'GAEvent' + icl_vars.current_language.toUpperCase() + category.charAt(0),
		'categorie': 'telechargement', 
		'action': icl_vars.current_language, 
		'label': category // $( 'h1', $( this ) ).text() 
	}); 
});

});